import { DatePicker as BaseDatePicker } from "@mui/x-date-pickers/DatePicker"
import { Controller, useFormContext } from "react-hook-form"
import { FormComponent } from "./FormBuilder/types"
import { parseISO } from "date-fns"

type DatePickerProps = {
  field: string
  component: FormComponent
  width?: string
}

export const DatePicker = ({ field: fieldName, component, width = "450px" }: DatePickerProps) => {
  const { control, watch, setValue } = useFormContext()
  const watchedValue = watch(fieldName)

  return (
    <>
      {watchedValue ? (
        <Controller
          name={fieldName}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <BaseDatePicker
              readOnly={!component.editable}
              sx={{ width }}
              {...field}
              value={parseISO(watchedValue)}
              onChange={(value) => setValue(fieldName, value?.toISOString())}
            />
          )}
        />
      ) : null}
    </>
  )
}
